import { Link, StaticQuery, graphql } from "gatsby";
import SocialMedia from "./social-media";
import Container from "./container";
import Icon from "./icon";
import PortableText from "./portableText";
import React from "react";
import { phoneUrl } from "../lib/helpers";
import { cn } from "../lib/helpers";

import * as styles from "../styles/components/footer.module.css";

const query = graphql`
  query FooterQuery {
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      title
      footerNavigation {
        _key
        heading
        links {
          _key
          blank
          text
          url
        }
      }
      contactInfoHeading
      _rawAddress
      generalContact {
        email
        phone
      }
      socialMedia {
        _key
        link
        title
      }
    }
    bottomlinks: allSanityNav(filter: { title: { eq: "Bottom Links" } }) {
      edges {
        node {
          navItems {
            _key
            blank
            url
            text
          }
        }
      }
    }
  }
`;

const Footer = () => {

  function handleToggleSubNav(e) {
    e.preventDefault();
    e.target.parentElement.classList.toggle(styles.active);
  }

  return(
  <StaticQuery
    query={query}
    render={data => (
      <footer className={styles.root}>
        <Container>
          <div className={styles.top}>
            <div className={cn("grid", styles.customGrid)}>
              <div className={cn("col-12 col-xl-2", styles.item)}>
                <div className={styles.branding}>
                  <Link to="/"><Icon symbol="logo" /></Link>
                </div>
              </div>
              {data.site.footerNavigation && 
                <>
                {data.site.footerNavigation.map(linksBlock => {
                  return (
                    <div className={cn("col-12 col-md-4 col-lg col-xl-2", styles.item, styles.itemAccordion)} key={linksBlock._key}>
                      {linksBlock.heading && <h6 className={cn("h5", styles.heading)} onClick={handleToggleSubNav}>{linksBlock.heading}<div className="d-hide"><Icon symbol="plus" /><Icon symbol="minus" /></div></h6>}
                      {linksBlock.links &&
                        <ul className={styles.linkList}>
                          {linksBlock.links.map(link => {
                            return (
                              <li key={link._key}>
                                {link.blank
                                  ? <a href={link.url} target="_blank" rel="noreferrer">{link.text}</a>
                                  : <Link to={link.url}>{link.text}</Link>
                                }
                              </li>
                            );
                          })}
                        </ul>
                      }
                    </div>
                  );
                })}
                </>
              }
              <div className={cn("col-12 col-md-4 col-lg col-xl-2", styles.item, styles.itemContacts)}>
                {data.site.contactInfoHeading && <h6 className={cn("h5", styles.heading)}>{data.site.contactInfoHeading}</h6>}
                {data.site._rawAddress && 
                  <div className={styles.address}>
                    <PortableText blocks={data.site._rawAddress} />
                  </div>
                }
                {data.site.generalContact && (data.site.generalContact.phone || data.site.generalContact.email) && 
                  <div className={styles.contacts}>
                    {data.site.generalContact.phone && <a href={"tel:"+phoneUrl(data.site.generalContact.phone)} rel="noreferrer">{data.site.generalContact.phone}</a>}
                    {data.site.generalContact.phone && data.site.generalContact.email && <br />}
                    {data.site.generalContact.email && <a href={"mailto:"+data.site.generalContact.email} rel="noreferrer">{data.site.generalContact.email}</a>}
                  </div>
                }
                <div>
                  <SocialMedia items={data.site.socialMedia} dark="true" />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.bottom}>
            <div className="grid justify-lg-between">
              <div className="col-12 col-lg-auto">
                {data.site.title &&
                  <div className={styles.copyright}>
                    {new Date().getFullYear()} &copy; {data.site.title}. All rights reserved.
                  </div>
                }
              </div>
              <div className="col-12 col-lg-auto">
                <nav>
                  {data && data.bottomlinks.edges.map(({node: bottomlinks}) => (
                    <>
                      {bottomlinks.navItems &&
                        <ul className={styles.bottomLinks}>
                          {bottomlinks.navItems.map(navItems => (
                            <li key={navItems._key}>
                              {navItems.blank
                                ? <a href={navItems.url} className={navItems.class} target="_blank" rel="noreferrer">{navItems.text}</a>
                                : <Link to={navItems.url} className={navItems.class}>{navItems.text}</Link>
                              }
                            </li>
                          ))}
                          {<li><a href={"#"} className="termly-display-preferences">Consent Preferences</a></li>}
                        </ul>
                      }
                    </>
                  ))}
                </nav>
              </div>
            </div>
          </div>
        </Container>
      </footer>
    )}
  />
)};

export default Footer;
